import fetchInstance from "@/services/fetch.ts";

export async function renamePlaylist(
  id: string,
  name: string,
  uniqueTabId: string,
) {
  try {
    return fetchInstance.put(
      `/playlist/rename`,
      {
        id,
        name,
        uniqueTabId,
      },
    );
  } catch (error) {
    console.log("Fout bij het updaten van de playlist name:", error)

    throw error;
  }
}

export async function changePlaylistParent(
  id: string,
  newParentId: string,
  uniqueTabId: string,
) {
  try {
    return fetchInstance.put(
      `/playlist/change-parent`,
      {
        id,
        newParentId,
        uniqueTabId,
      },
    );
  } catch (error) {
    console.log("Fout bij het updaten van de playlist parent:", error)

    throw error;
  }
}

export async function createPlaylist(
  name: string,
  parentPlaylistId: string | null,
  uniqueTabId: string | null,
  bandWorkspaceId?: number | null,
) {
  try {
    return await fetchInstance.post(
      `/playlist/create`,
      { parentPlaylistId, name, uniqueTabId, bandWorkspaceId },
    );
  } catch (error) {
    console.log("Fout bij het maken van de playlist:", error)

    throw error;
  }
}

export async function deletePlaylist(
  explorerItemId: string,
  uniqueTabId: string,
) {
  try {
    return await fetchInstance.delete(
      `/playlist/${explorerItemId}/delete`,
      {
        uniqueTabId,
      },
    );
  } catch (error) {
    console.log("Fout bij het verwijderen van de playlist:", error)

    throw error;
  }
}

export async function fetchPlaylist(id: string) {
  try {
    const response = await fetchInstance.get(`/playlist/${id}`);
    if (!response.ok) {
      return null
    }
    return await response.json()
  } catch (error) {
    console.log("Fout bij het ophalen de playlist:", error)

    throw error;
  }
}
